<div data-testid="logins-per-day" class="logins-per-day">
  <header class="logins-per-day__header">
    <div class="logins-per-day__titles">
      <h4 class="logins-per-day__title">Logins per day</h4>
      <p *ngIf="hasLogins" data-testid="logins-subtitle" class="logins-per-day__subtitle">{{ subtitle }}</p>
    </div>
  </header>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="logins-failed" icon="fa-regular fa-circle-exclamation"
                             [title]="failedTitle" body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="loaded && !failed && !hasLogins" data-testid="logins-empty" icon="fa-regular fa-chart-line"
                             [title]="'No logins in this view'" body="Widen the filters or the period."></app-admin-dashboard-empty>
  <div *ngIf="loaded && hasLogins" #chart data-testid="logins-chart" class="logins-per-day__chart"></div>
  <div *ngIf="!loaded" class="logins-per-day__chart"></div>
  <p *ngIf="data?.historyFrom" data-testid="logins-history" class="logins-per-day__history">Collecting history — trend available from {{ data.historyFrom | date:'d MMM y':'UTC' }}</p>
</div>
